import { Sentiment } from '@/types';

interface SentimentBadgeProps {
  sentiment: Sentiment;
  label?: string;
  className?: string;
}

export function SentimentBadge({ sentiment, label, className = '' }: SentimentBadgeProps) {
  let defaultLabel = '';
  let colorClass = '';

  switch (sentiment) {
    case 'positive':
      defaultLabel = '利多';
      colorClass = 'bg-red-50/80 text-red-600 border border-red-200/60 dark:bg-red-950/30 dark:text-red-400 dark:border-red-900/50';
      break;
    case 'negative':
      defaultLabel = '利空';
      colorClass = 'bg-emerald-50/80 text-emerald-600 border border-emerald-200/60 dark:bg-emerald-950/30 dark:text-emerald-400 dark:border-emerald-900/50';
      break;
    case 'neutral':
    default:
      defaultLabel = '中性';
      colorClass = 'bg-slate-100/80 text-slate-600 border border-slate-200/60 dark:bg-slate-800/50 dark:text-slate-300 dark:border-slate-700/50';
      break;
  }

  return (
    <span className={`inline-flex items-center justify-center px-2 py-0.5 rounded-md text-[11px] font-medium tracking-wide ${colorClass} ${className}`}>
      {label || defaultLabel}
    </span>
  );
}
